<template>
    <modal name="cek_ongkir" :width="'90%'" :height="'auto'" :adaptive="true" :scrollable="true" class="shipping-modal">
        <div class="shipping-cost-modal">
            <div class="modal-header-shipping">
                <div class="modal-icon-shipping">
                    <i class="fas fa-truck"></i>
                </div>
                <div class="modal-title-section">
                    <h4 class="modal-title-shipping">Shipping Cost Calculator</h4>
                    <p class="modal-subtitle-shipping">Calculate shipping costs for customer orders</p>
                </div>
                <button class="modal-close-btn" @click="$modal.hide('cek_ongkir')">
                    <i class="fas fa-times"></i>
                </button>
            </div>

            <div class="modal-body-shipping">
                <form id="frmHitungOngkir" v-on:submit.prevent="hitungOngkir" class="shipping-form">
                    <!-- Origin Section -->
                    <div class="form-section">
                        <div class="section-header">
                            <i class="fas fa-map-marker-alt"></i>
                            <h5 class="section-title">Origin</h5>
                        </div>
                        <div class="form-row">
                            <div class="form-group-modern">
                                <label class="form-label-modern">Store Location</label>
                                <select class="modern-select" name="origin" id="toko">
                                    <option v-for="data in listToko" v-bind:key="data.id" v-bind:value="data.id">{{ data.label}}</option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <!-- Destination Section -->
                    <div class="form-section">
                        <div class="section-header">
                            <i class="fas fa-location-arrow"></i>
                            <h5 class="section-title">Destination</h5>
                        </div>
                        <div class="form-row">
                            <div class="form-group-modern">
                                <label class="form-label-modern">Province</label>
                                <div v-if="isProvinceLoading" class="loading-indicator">
                                    <div class="spinner-border spinner-small" role="status"></div>
                                    <span>Loading provinces...</span>
                                </div>
                                <multiselect
                                    v-else
                                    v-model="province"
                                    tag-placeholder="Select Province"
                                    placeholder="Search Province"
                                    label="province"
                                    track-by="province_id"
                                    :options="provinces"
                                    :multiple="false"
                                    :show-labels="false"
                                    class="modern-multiselect"
                                ></multiselect>
                            </div>
                            <div class="form-group-modern">
                                <label class="form-label-modern">City</label>
                                <div v-if="isCityLoading" class="loading-indicator">
                                    <div class="spinner-border spinner-small" role="status"></div>
                                    <span>Loading cities...</span>
                                </div>
                                <multiselect
                                    v-else
                                    v-model="city"
                                    tag-placeholder="Select City"
                                    placeholder="Search City"
                                    label="label"
                                    track-by="city_id"
                                    :options="cities"
                                    :multiple="false"
                                    :show-labels="false"
                                    class="modern-multiselect"
                                ></multiselect>
                            </div>
                            <div class="form-group-modern">
                                <label class="form-label-modern">District</label>
                                <div v-if="isSubdistrictLoading" class="loading-indicator">
                                    <div class="spinner-border spinner-small" role="status"></div>
                                    <span>Loading districts...</span>
                                </div>
                                <multiselect
                                    v-else
                                    v-model="kec_tujuan"
                                    tag-placeholder="Select District"
                                    placeholder="Search District"
                                    label="subdistrict_name"
                                    track-by="subdistrict_id"
                                    :options="subdistricts"
                                    :multiple="false"
                                    :show-labels="false"
                                    class="modern-multiselect"
                                ></multiselect>
                            </div>
                        </div>
                    </div>

                    <!-- Package Details Section -->
                    <div class="form-section">
                        <div class="section-header">
                            <i class="fas fa-box"></i>
                            <h5 class="section-title">Package Details</h5>
                        </div>
                        <div class="form-row">
                            <div class="form-group-modern">
                                <label class="form-label-modern">Weight</label>
                                <div class="input-with-unit">
                                    <input
                                        type="number"
                                        name="weight"
                                        id="berat"
                                        class="modern-input"
                                        placeholder="Enter weight"
                                        min="1"
                                        required
                                    />
                                    <span class="unit-label">Gram</span>
                                </div>
                            </div>
                            <div class="form-group-modern">
                                <label class="form-label-modern">Courier</label>
                                <select class="modern-select" name="courier" id="kurir" required>
                                    <option value="">Select Courier</option>
                                    <option v-for="data in dataKurir" v-bind:key="data.idx" :value="data.idx">{{ data.nama }}</option>
                                </select>
                            </div>
                            <div class="form-group-modern">
                                <label class="form-label-modern">&nbsp;</label>
                                <button type="submit" class="btn-calculate">
                                    <i class="fas fa-calculator mr-2"></i>
                                    Calculate Shipping Cost
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>

            <!-- Results Section -->
            <div v-if="ongkir && ongkir.length > 0" class="results-section">
                <div class="results-header">
                    <i class="fas fa-list-ul"></i>
                    <h5 class="results-title">Shipping Options</h5>
                    <span class="results-count">{{ ongkir.length }} options found</span>
                </div>

                <div class="shipping-results">
                    <div v-for="(option, index) in ongkir" :key="index" class="shipping-option">
                        <div class="option-header">
                            <div class="courier-info">
                                <span class="courier-name">{{ kodeKurir }}</span>
                                <span class="service-name">{{ option.service }}</span>
                            </div>
                            <div class="option-price">
                                <span class="price-amount">{{ option.cost[0].value.toLocaleString('id-ID', { style: 'currency', currency: 'IDR', maximumFractionDigits: 0 }) }}</span>
                                <button class="btn-copy" @click="copyOngkir(index)" title="Copy to clipboard">
                                    <i class="fas fa-copy"></i>
                                </button>
                            </div>
                        </div>
                        <div class="option-details">
                            <div class="detail-item">
                                <i class="fas fa-clock"></i>
                                <span>{{ option.cost[0].etd }} days estimated</span>
                            </div>
                            <div class="detail-item">
                                <i class="fas fa-info-circle"></i>
                                <span>{{ option.description }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Empty State -->
            <div v-else-if="ongkir && ongkir.length === 0" class="empty-results">
                <div class="empty-icon">
                    <i class="fas fa-search"></i>
                </div>
                <h5 class="empty-title">No shipping options found</h5>
                <p class="empty-description">Try adjusting your search criteria or select different locations.</p>
            </div>

            <div class="modal-footer-shipping">
                <button type="button" class="btn-close-modal" @click="$modal.hide('cek_ongkir')">
                    <i class="fas fa-times mr-1"></i>
                    Close
                </button>
            </div>
        </div>
    </modal>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
    name: 'ShippingModal',
    components: {
        Multiselect
    },
    props: {
        listToko: {
            type: Array,
            default: () => []
        },
        provinces: {
            type: Array,
            default: () => []
        },
        cities: {
            type: Array,
            default: () => []
        },
        subdistricts: {
            type: Array,
            default: () => []
        },
        province: {
            type: Object,
            default: null
        },
        city: {
            type: Object,
            default: null
        },
        kec_tujuan: {
            type: Object,
            default: null
        },
        isProvinceLoading: {
            type: Boolean,
            default: false
        },
        isCityLoading: {
            type: Boolean,
            default: false
        },
        isSubdistrictLoading: {
            type: Boolean,
            default: false
        },
        dataKurir: {
            type: Array,
            default: () => []
        },
        ongkir: {
            type: Array,
            default: () => []
        },
        kodeKurir: {
            type: String,
            default: ''
        }
    },
    methods: {
        hitungOngkir() {
            this.$emit('calculate-shipping');
        },
        copyOngkir(index) {
            this.$emit('copy-shipping', index);
        }
    }
};
</script>

<style scoped>
/* Shipping Modal Styles */
.shipping-modal .modal-dialog {
    margin: 2rem auto;
    max-width: 900px;
}

.shipping-cost-modal {
    background: white;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
}

.modal-header-shipping {
    background: #f8f9fa;
    border-bottom: 1px solid #e9ecef;
    padding: 20px 24px;
    display: flex;
    align-items: center;
    gap: 16px;
    position: relative;
}

.modal-icon-shipping {
    width: 40px;
    height: 40px;
    background: #25d366;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.1rem;
    flex-shrink: 0;
    color: white;
}

.modal-title-section {
    flex: 1;
}

.modal-title-shipping {
    font-size: 1.3rem;
    font-weight: 600;
    margin: 0 0 4px 0;
    color: #212529;
}

.modal-subtitle-shipping {
    font-size: 0.85rem;
    color: #6c757d;
    margin: 0;
}

.modal-close-btn {
    background: none;
    border: none;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    color: #6c757d;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
    flex-shrink: 0;
}

.modal-close-btn:hover {
    background: #e9ecef;
    color: #212529;
}

.modal-body-shipping {
    padding: 24px;
    max-height: 70vh;
    overflow-y: auto;
}

.shipping-form {
    display: flex;
    flex-direction: column;
    gap: 24px;
}

.form-section {
    background: #f8f9fa;
    border-radius: 12px;
    padding: 20px;
    border: 1px solid #e9ecef;
}

.section-header {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 16px;
}

.section-header i {
    color: #007bff;
    font-size: 1.1rem;
}

.section-title {
    font-size: 1.1rem;
    font-weight: 600;
    color: #212529;
    margin: 0;
}

.form-row {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 16px;
}

.form-group-modern {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.form-label-modern {
    font-weight: 600;
    color: #212529;
    font-size: 0.9rem;
}

.modern-select,
.modern-input {
    padding: 12px 16px;
    border: 2px solid #e9ecef;
    border-radius: 8px;
    font-size: 1rem;
    transition: all 0.3s ease;
    background: white;
}

.modern-select:focus,
.modern-input:focus {
    border-color: #007bff;
    box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.1);
    outline: none;
}

.modern-multiselect {
    background: white;
    border-radius: 8px;
}

.modern-multiselect .multiselect__tags {
    border: 2px solid #e9ecef;
    border-radius: 8px;
    padding: 8px 16px;
}

.modern-multiselect .multiselect__tags:focus-within {
    border-color: #007bff;
    box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.1);
}

.input-with-unit {
    position: relative;
}

.unit-label {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    color: #6c757d;
    font-size: 0.9rem;
    font-weight: 500;
    pointer-events: none;
}

.input-with-unit .modern-input {
    padding-right: 60px;
}

.btn-calculate {
    background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
    color: white;
    border: none;
    padding: 12px 24px;
    border-radius: 8px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
}

.btn-calculate:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(40, 167, 69, 0.3);
}

.loading-indicator {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px 16px;
    background: #f8f9fa;
    border-radius: 8px;
    color: #6c757d;
    font-size: 0.9rem;
}

.spinner-small {
    width: 1rem;
    height: 1rem;
}

/* Results Section */
.results-section {
    margin-top: 24px;
    padding-top: 24px;
    border-top: 2px solid #e9ecef;
}

.results-header {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 20px;
}

.results-header i {
    color: #007bff;
    font-size: 1.2rem;
}

.results-title {
    font-size: 1.2rem;
    font-weight: 600;
    color: #212529;
    margin: 0;
    flex: 1;
}

.results-count {
    background: #007bff;
    color: white;
    padding: 4px 8px;
    border-radius: 12px;
    font-size: 0.8rem;
    font-weight: 500;
}

.shipping-results {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.shipping-option {
    background: white;
    border: 1px solid #e9ecef;
    border-radius: 12px;
    padding: 16px;
    transition: all 0.3s ease;
}

.shipping-option:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    border-color: #007bff;
}

.option-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
}

.courier-info {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.courier-name {
    font-weight: 600;
    color: #212529;
    font-size: 1rem;
}

.service-name {
    color: #6c757d;
    font-size: 0.9rem;
}

.option-price {
    display: flex;
    align-items: center;
    gap: 12px;
}

.price-amount {
    font-size: 1.1rem;
    font-weight: 700;
    color: #28a745;
}

.btn-copy {
    background: #007bff;
    color: white;
    border: none;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
}

.btn-copy:hover {
    background: #0056b3;
    transform: scale(1.05);
}

.option-details {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.detail-item {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 0.9rem;
    color: #6c757d;
}

.detail-item i {
    width: 16px;
    color: #007bff;
}

/* Empty Results */
.empty-results {
    text-align: center;
    padding: 40px 20px;
}

.empty-icon {
    font-size: 4rem;
    color: #dee2e6;
    margin-bottom: 20px;
}

.empty-title {
    color: #495057;
    font-size: 1.5rem;
    font-weight: 600;
    margin-bottom: 10px;
}

.empty-description {
    color: #6c757d;
    font-size: 1rem;
    line-height: 1.5;
    max-width: 400px;
    margin: 0 auto;
}

/* Modal Footer */
.modal-footer-shipping {
    background: #f8f9fa;
    padding: 20px 24px;
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    border-top: 1px solid #e9ecef;
}

.btn-close-modal {
    background: #6c757d;
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 8px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    gap: 8px;
}

.btn-close-modal:hover {
    background: #5a6268;
    transform: translateY(-1px);
}

/* Responsive Shipping Modal */
@media (max-width: 768px) {
    .shipping-modal .modal-dialog {
        margin: 1rem;
        max-width: none;
    }

    .modal-header-shipping {
        padding: 20px;
        flex-direction: column;
        text-align: center;
        gap: 12px;
    }

    .modal-title-shipping {
        font-size: 1.3rem;
    }

    .modal-body-shipping {
        padding: 20px;
    }

    .form-row {
        grid-template-columns: 1fr;
    }

    .option-header {
        flex-direction: column;
        align-items: flex-start;
        gap: 8px;
    }

    .option-price {
        align-self: flex-end;
    }

    .modal-footer-shipping {
        padding: 16px 20px;
        flex-direction: column;
    }

    .btn-close-modal {
        width: 100%;
        justify-content: center;
    }
}
</style>
